import { getWindowObject } from '../../../utils/window';
import type { ICrossOriginCommunicator, OutgoingInfo } from '../types';
import { OutgoingMessage } from '../types';

import { CrossOriginCommunicationDefaultProcessor } from './CrossOriginCommunicationDefaultProcessor';
import { CrossOriginCommunicationDefaultSender } from './CrossOriginCommunicationDefaultSender';

export class CrossOriginCommunicationDefault implements ICrossOriginCommunicator {
  process(message: MessageEvent<never>, store: never): void {
    CrossOriginCommunicationDefaultProcessor(message.data, store);
  }

  send(message: OutgoingMessage, info: OutgoingInfo): void {
    const data = CrossOriginCommunicationDefaultSender(message, info);
    if (data) {
      getWindowObject().top?.postMessage(data, '*');
    }
  }
}

export default new CrossOriginCommunicationDefault();
